var main = {
    jsToggles: function() {
        var linkToggle = document.querySelectorAll('.js-toggle');

        for(i = 0; i < linkToggle.length; i++) {
        linkToggle[i].addEventListener('click', function(event) {
        
        event.preventDefault();
        
        var container = document.getElementById(this.dataset.container);
        
        if (!container.classList.contains('active')) {
            this.classList.add('is-open');
            container.classList.add('active');
            container.style.height = 'auto';
        
            var height = container.clientHeight + 'px';
        
            container.style.height = '0px';
        
            var parentContainer = container.closest('.sub-parent')
        
        
            setTimeout(function () {
            container.style.height = height;
                if (parentContainer != undefined && parentContainer.clientHeight > 0) {
                setTimeout( function() {
                    parentContainer.style.height = 'auto';
                    var parentHeight = parentContainer.clientHeight + 'px';
            
                    parentContainer.style.height = '0px';
        
                    parentContainer.style.height = parentHeight;
                }, 100)
                }
            }, 0);
            
        } else {
            this.classList.remove('is-open');
            
            container.style.height = '0px';
        
            if (container.classList.contains('no-trans')) {
            container.classList.remove('active');
            } else {
            container.addEventListener('transitionend', function () {
                container.classList.remove('active');
            }, {
                once: true
            });
            }
            
            setTimeout(function () {
            var parentContainer = container.closest('.sub-parent')
            var innerSub = container.closest('.inner-sub')
        
            if (innerSub != null) {
                parentContainer.style.height = innerSub.clientHeight + 'px';
            }
            }, 100);
        }
        
        });
        
        }
    }
}

main.jsToggles()








// Clean Read More Function - Simple and Effective
document.addEventListener('DOMContentLoaded', function() {
  const productDescriptions = document.querySelectorAll('.product__description');
  
  productDescriptions.forEach(function(description) {
    // Check schema setting - skip if disabled
    if (description.dataset.enableReadmore === 'false') return;
    
    const fullHTML = description.innerHTML.trim();
    
    // Get text length to check if we need read more
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = fullHTML;
    const fullText = tempDiv.textContent || tempDiv.innerText || '';
    
    if (fullText.length > 210) {
      // Create the truncated version
      const truncatedHTML = truncateHTMLPreservingStructure(fullHTML, 210);
      
      // Create the wrapper div that will contain everything
      const wrapper = document.createElement('div');
      wrapper.className = 'description-content';
      
      // Create the button
      const readMoreBtn = document.createElement('button');
      readMoreBtn.className = 'read-more-btn';
      readMoreBtn.textContent = 'Read more';
      readMoreBtn.setAttribute('aria-expanded', 'false');
      
      // Set up the collapsed state
      wrapper.innerHTML = truncatedHTML;
      wrapper.appendChild(readMoreBtn);
      
      // Replace the original content
      description.innerHTML = '';
      description.appendChild(wrapper);
      
      // Add click handler
      readMoreBtn.addEventListener('click', function() {
        const isExpanded = readMoreBtn.getAttribute('aria-expanded') === 'true';
        
        if (isExpanded) {
          // Collapse
          wrapper.innerHTML = truncatedHTML;
          wrapper.appendChild(readMoreBtn);
          readMoreBtn.textContent = 'Read more';
          readMoreBtn.setAttribute('aria-expanded', 'false');
        } else {
          // Expand
          wrapper.innerHTML = fullHTML;
          wrapper.appendChild(readMoreBtn);
          readMoreBtn.textContent = 'Read less';
          readMoreBtn.setAttribute('aria-expanded', 'true');
        }
      });
    }
  });
});

function truncateHTMLPreservingStructure(html, maxChars) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(`<div>${html}</div>`, 'text/html');
  const container = doc.querySelector('div');
  
  let charCount = 0;
  let truncated = false;
  
  function processElement(element) {
    const clone = element.cloneNode(false);
    
    for (const child of element.childNodes) {
      if (truncated) break;
      
      if (child.nodeType === Node.TEXT_NODE) {
        const text = child.textContent;
        const remainingChars = maxChars - charCount;
        
        if (text.length <= remainingChars) {
          clone.appendChild(child.cloneNode());
          charCount += text.length;
        } else {
          // Truncate the text and add ellipsis
          let truncatedText = text.substring(0, remainingChars);
          
          // Try to end at a word boundary
          const lastSpace = truncatedText.lastIndexOf(' ');
          if (lastSpace > remainingChars * 0.7) {
            truncatedText = truncatedText.substring(0, lastSpace);
          }
          
          // Add the truncated text with ellipsis
          clone.appendChild(document.createTextNode(truncatedText + '...'));
          truncated = true;
          break;
        }
      } else if (child.nodeType === Node.ELEMENT_NODE) {
        // Handle special elements that should always be preserved
        const tagName = child.tagName.toLowerCase();
        const className = child.className || '';
        const isSpecial = ['svg', 'img', 'i'].includes(tagName) || 
                         className.includes('icon') || 
                         className.includes('check') || 
                         className.includes('symbol');
        
        if (isSpecial) {
          clone.appendChild(child.cloneNode(true));
        } else {
          const processedChild = processElement(child);
          if (processedChild.hasChildNodes() || processedChild.textContent.trim()) {
            clone.appendChild(processedChild);
          }
        }
      }
    }
    
    return clone;
  }
  
  const result = processElement(container);
  return result.innerHTML;
}




// Close all accordions on page load
document.addEventListener('DOMContentLoaded', function() {
  // Find all details elements within accordion containers
  const accordionDetails = document.querySelectorAll('.product__accordion details');
  
  accordionDetails.forEach(function(details) {
    // Remove the 'open' attribute to close the accordion
    details.removeAttribute('open');
    
    // Update aria-expanded on the summary element
    const summary = details.querySelector('summary');
    if (summary) {
      summary.setAttribute('aria-expanded', 'false');
    }
  });
});




// feature typeface
document.addEventListener('DOMContentLoaded', function() {
  // Just add new selectors to this array
  const headingTargets = [
    '.featured-collection__heading-template--18443661934804__featured_collection_wjDP3Y',
    '.iwt__heading-template--18443661934804__image_with_text_dPmr46',
    '.iwt__heading-template--18443661934804__image_with_text_gUnkNn',
    '.rich-text__block-heading-template--18443661934804__rich_text_Nip6aD',
    '.collection__title h2',
    '.template-product h2',
    '.template-collection h2'
    // Add more as needed...
  ];
  
  // Apply heading-lead class to all targets
  headingTargets.forEach(selector => {
    document.querySelectorAll(selector).forEach(el => {
      el.classList.add('heading-lead');
    });
  });
});



// Remove "Estimated between" delivery date from cart
(function() {
  function removeEstimatedDelivery() {
    const productOptions = document.querySelectorAll('.product-option');
    
    productOptions.forEach(option => {
      const dt = option.querySelector('dt');
      if (dt && dt.textContent.trim() === 'Estimated between:') {
        option.remove();
      }
    });
  }
  
  // Run on page load
  removeEstimatedDelivery();
  
  // Run again after cart updates (for AJAX carts)
  document.addEventListener('DOMContentLoaded', removeEstimatedDelivery);
  
  // Watch for cart changes (if using dynamic cart)
  const observer = new MutationObserver(removeEstimatedDelivery);
  observer.observe(document.body, { childList: true, subtree: true });
})();


  // REMOVE VERTICAL FROM NAV LIST ITEM
document.addEventListener('DOMContentLoaded', function() {
  // Select all product title elements in the menu drawer
  const productTitles = document.querySelectorAll('.ddb__menu-drawer__collection--product-title');
  
  // Loop through each title and remove "Vertical"
  productTitles.forEach(function(title) {
    title.textContent = title.textContent.replace(/\s*Vertical\s*/gi, ' ').trim();
  });
});





// landing-page wrapping shadow
(function() {
  // Check if this is a landing page (has 'lp-' in any body class)
  const isLandingPage = Array.from(document.body.classList).some(className =>
    className.includes('lp-')
  );

  if (!isLandingPage) {
    return;
  }

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wrapSections);
  } else {
    wrapSections();
  }

  function wrapSections() {
    const main = document.querySelector('#MainContent');
    if (!main) return;

    // Get all direct children sections/divs with shopify-section class
    const allSections = Array.from(main.children).filter(child => 
      child.classList.contains('shopify-section') || 
      child.id.includes('shopify-section')
    );

    // Skip the first section
    const sectionsToWrap = allSections.slice(1);
    
    if (sectionsToWrap.length === 0) return;

    // Create the wrapper div
    const wrapper = document.createElement('div');
    wrapper.className = 'boxed-in-shadow';

    // Insert wrapper after the first section
    const firstSection = allSections[0];
    firstSection.parentNode.insertBefore(wrapper, firstSection.nextSibling);

    // Move all sections (except first) into the wrapper
    sectionsToWrap.forEach(section => {
      wrapper.appendChild(section);
    });

    // Add the styles
    addStyles();
  }

  function addStyles() {
    // Check if styles already exist
    if (document.getElementById('boxed-in-shadow-styles')) return;

    const style = document.createElement('style');
    style.id = 'boxed-in-shadow-styles';
    style.textContent = `
      .boxed-in-shadow {
        max-width: 1400px;
        margin: 0 auto;
        background: #ffffff;
        box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 
                    0 2px 4px -1px rgba(0, 0, 0, 0.06);
        border-radius: 8px;
        overflow: hidden;
      }

      /* Adjust on mobile for less shadow/padding */
      @media screen and (max-width: 749px) {
        .boxed-in-shadow {
          margin: 0 10px;
          box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.08);
        }
      }
    `;
    document.head.appendChild(style);
  }
})();






// Wait for DOM to be ready
document.addEventListener('DOMContentLoaded', function() {
  const bikeSwitcher = document.querySelector('.bike-rack-switcher');
  const colorVariant = document.querySelector('#custom-unified-color');
  
  if (bikeSwitcher && colorVariant) {
    // Create wrapper div
    const wrapper = document.createElement('div');
    wrapper.style.cssText = 'display: flex; gap: 20px; align-items: center; margin-bottom: 20px;';
    
    // Style the components
    bikeSwitcher.style.cssText = 'flex: 1;';
    colorVariant.style.cssText = 'margin-bottom: 0;';
    
    // Insert wrapper before bikeSwitcher
    bikeSwitcher.parentNode.insertBefore(wrapper, bikeSwitcher);
    
    // Move both elements into wrapper
    wrapper.appendChild(bikeSwitcher);
    wrapper.appendChild(colorVariant);
  }
});




  document.addEventListener('DOMContentLoaded', function() {
    const firstProduct = document.querySelector('#Slide-template--20487477657812__featured_collection_CGTiC9-1 .card__inner');
    if (firstProduct) {
      const badge = document.createElement('div');
      badge.className = 'popular-choice-badge';
      badge.textContent = '80% Choose This';
      firstProduct.insertBefore(badge, firstProduct.firstChild);
    }
  });
